/**
 * Feature flags — funzioni nascoste senza cancellare il codice.
 * Riattivare solo quando il servizio è realmente attivo.
 */
// Servizi a pagamento (abbonamento Plus, booking Host, vendita prodotti, offerte parrocchie)
export const SHOW_PAID_SERVICES = false;
